import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Modal, Input } from 'antd'

import { createApplication } from '../../redux/appList/actions'

class modalCreateApplication extends React.Component {
    constructor() {
        super()
        this.state = {
            name: ''
        }
    }

    onConfirm = () => {
        const { createApplication } = this.props
        createApplication({ name: this.state.name })
    }

    handleNameChange = event => {
        this.setState({ name: event.target.value })
    }

    render() {
        const { visible, onClose, loading } = this.props

        return (
            <Modal
                visible={visible}
                title="Create Application"
                okText="Confirm"
                cancelText="Cancel"
                onOk={this.onConfirm}
                onCancel={onClose}
                confirmLoading={loading}
            >
                <p>Application Name</p>
                <Input onPressEnter={this.onConfirm} onChange={this.handleNameChange} />

                {
                    // <p />
                    // <Alert message="Invalid application name" type="error" />
                }
            </Modal>
        )
    }
}

const mapStateToProps = ({ appList }) => ({
    loading: appList.loadingCreateApplication
})

const mapActionsToProps = dispatch => ({
    createApplication: bindActionCreators(createApplication, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(modalCreateApplication)
